export default __webpack_public_path__ + "static/media/cer11.f74bf844.png";